// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
type NonObject = undefined | null | boolean | string | number | Function | Date;
type NonConstructorKeys<T> = {
    [P in keyof T]: T[P] extends new () => unknown ? never : P;
}[keyof T];
type NonConstructor<T> = Pick<T, NonConstructorKeys<T>>;

/**
 * Removes non-data fns from an SDK DTO type
 */
type NonSdkClass<T> = NonConstructor<Omit<T, 'fromJS' | 'init' | 'toJSON'>>;

/**
 * Removes non-data fns from an SDK DTO type and all its child props
 */
export type RecurseNonSdkClass<T> = T extends undefined
    ? undefined
    : NonSdkClass<{
          [K in keyof T]: T[K] extends NonObject
              ? T[K]
              : T[K] extends Array<infer U>
                ? Array<RecurseNonSdkClass<U>>
                : RecurseNonSdkClass<T[K]>;
      }>;

export function toSdkClass<T>(
    type: { fromJS: (data: unknown) => T },
    data: RecurseNonSdkClass<T>,
): T {
    return type.fromJS(data);
}
